module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal lcbcft",
    class: {
      high: _vm.filling
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.filling) ? _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tDate de mise en relation\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-date-input"
  }, [_c('input-date', {
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tOrigine de la relation client\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.origins,
      "solo": true
    },
    model: {
      value: (_vm.origin),
      callback: function($$v) {
        _vm.origin = $$v
      },
      expression: "origin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tOuverture à distance\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tVigilance accrue exigée lorsque le client ou son représentant légal n'est pas physiquement présent au fins de l'identification (Art. L.561-10 1° du code monétaire et financier)\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.remoteContractualization),
      callback: function($$v) {
        _vm.remoteContractualization = $$v
      },
      expression: "remoteContractualization"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tCatégorie professionnelle\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select'),
      expression: "'required|select'"
    }],
    attrs: {
      "name": "catégorie professionnelle",
      "items": _vm.professionnalCategories,
      "solo": true
    },
    model: {
      value: (_vm.professionalCategory),
      callback: function($$v) {
        _vm.professionalCategory = $$v
      },
      expression: "professionalCategory"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('catégorie professionnelle')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tActivité risquée\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tIl s'agit de savoir si l'activité du client est plus ou moins risquée au sens du risque de blanchiment/financement du terrorisme\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.activityRisk),
      callback: function($$v) {
        _vm.activityRisk = $$v
      },
      expression: "activityRisk"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tSoupçon de fraude fiscale\n\t\t\t\t\t")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.suspicionOfFraud),
      callback: function($$v) {
        _vm.suspicionOfFraud = $$v
      },
      expression: "suspicionOfFraud"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tLe client exerce-t-il ou a-t-il exercé au cours des 12 derniers mois une fonction politique, juridictionnelle ou administrative importante ?\n\t\t\t\t\t")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.wasPJA),
      callback: function($$v) {
        _vm.wasPJA = $$v
      },
      expression: "wasPJA"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tLe client a-t-il un lien avec une personne de sa famille ou de son entourage qui exerce ou a exercé au cours des 12 derniers mois une fonction politique, juridictionnelle ou administrative importante ?\n\t\t\t\t\t")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.wasSomeonePJA),
      callback: function($$v) {
        _vm.wasSomeonePJA = $$v
      },
      expression: "wasSomeonePJA"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tClient VIP\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tUn VIP est un personnage publique important\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.isVIP),
      callback: function($$v) {
        _vm.isVIP = $$v
      },
      expression: "isVIP"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tNationalité (Nationalité principale)\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tChoix obligatoire\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select:true'),
      expression: "'required|select:true'"
    }],
    attrs: {
      "name": "nationalité",
      "items": _vm.countryList,
      "object": true,
      "solo": true
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nationalité')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tSeconde nationalité\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tChoix facultatif\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.countryList,
      "object": true,
      "solo": true
    },
    model: {
      value: (_vm.secondCountry),
      callback: function($$v) {
        _vm.secondCountry = $$v
      },
      expression: "secondCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tRésidence fiscale\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tChoix Obligatoire\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|select:true'),
      expression: "'required|select:true'"
    }],
    attrs: {
      "name": "résidence fiscale",
      "items": _vm.countryList,
      "object": true,
      "solo": true
    },
    model: {
      value: (_vm.fiscCountry),
      callback: function($$v) {
        _vm.fiscCountry = $$v
      },
      expression: "fiscCountry"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('résidence fiscale')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tBanque dépositaire\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "sublabel"
  }, [_vm._v("\n\t\t\t\t\t\tPays non cooperatifs : Guatemala, Niue, Brunei, Iles Marshall, Iles Vierges britanniques,\u2028Jersey, Montserrat, Nauru, Botswana, Bermudes\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.banqueCountries,
      "solo": true
    },
    model: {
      value: (_vm.banqueCountry),
      callback: function($$v) {
        _vm.banqueCountry = $$v
      },
      expression: "banqueCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tPoursuite pénale\n\t\t\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    model: {
      value: (_vm.penal),
      callback: function($$v) {
        _vm.penal = $$v
      },
      expression: "penal"
    }
  })], 1), _vm._v(" "), (_vm.errorInForm) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("Une erreur est présente dans le formulaire")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.sendScore
    }
  }, [_vm._v("Calculer le score")])])])]) : _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-result-score row"
  }, [_c('div', {
    staticClass: "value",
    class: _vm.resolveClass()
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.displayScore()) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t\tVigilence "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.score_label))])]), _vm._v(" "), (_vm.score > 3) ? _c('div', {
    staticClass: "subname"
  }, [_vm._v("\n\t\t\t\t\t\t\tUne alerte va être envoyé aux Super Admin\n\t\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        _vm.filling = true
      }
    }
  }, [_vm._v("Revoir mes réponses")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.end
    }
  }, [_vm._v("Terminer")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n  \t\t\t\tQuestionnaire\n  \t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tLutte contre le blanchiment des capitaux "), _c('br'), _vm._v("\n\t\t\t\t\tet le financement du terrorisme\n\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sublink",
    attrs: {
      "href": "https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Info-Soupc%CC%A7on-Fraude-Fiscale.pdf",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-info-2"
  }), _vm._v(" Plus d'informations sur le soupçon de fraude fiscale")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sublink",
    attrs: {
      "href": "https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Infos-PPE.pdf",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-info-2"
  }), _vm._v(" Plus d'informations sur les PPE (Personnes Politiquement Exposées)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sublink",
    attrs: {
      "href": "https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Infos-PPE.pdf",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-info-2"
  }), _vm._v(" Plus d'informations sur les PPE (Personnes Politiquement Exposées)")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d39b98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/LCBCFT.vue
// module id = 1091
// module chunks = 0